<template>
    <div class="form-section address">
      <template v-if="$store.getters['user/isHirer']">
        <div class="form-group vanilla address-full">
          <label
            >Address</label
          >
          <auto-complete-address
            @placechanged="fillAddress"
          ></auto-complete-address>
        </div>
        <div class="tablet-hidden">&nbsp;</div>
        <div
          class="form-group vanilla"
          :class="{
            'has-input-error': errors['billing_address.sub_premises_number'],
          }"
        >
          <label :for="`profile-billing-address-sub-premises-number_${this._uid}`"
            >Unit/Flat</label
          >
          <input
            :id="`profile-billing-address-sub-premises-number_${this._uid}`"
            type="text"
            v-model="data.billing_address.sub_premises_number"
            placeholder="Enter unit/flat"
          />
          <input-error v-if="errors['billing_address.sub_premises_number']">
            {{ errors["billing_address.sub_premises_number"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors['billing_address.street_number'] }"
        >
          <label :for="`profile-billing-address-street-number_${this._uid}`"
            >Street number <span class="required">*</span></label
          >
          <input
            :id="`profile-billing-address-street-number_${this._uid}`"
            type="text"
            v-model="data.billing_address.street_number"
            @keydown="delete errors['billing_address.street_number']"
            placeholder="Enter street number"
          />
          <input-error v-if="errors['billing_address.street_number']">
            {{ errors["billing_address.street_number"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-street-address"
          :class="{ 'has-input-error': errors['billing_address.street_address'] }"
        >
          <label :for="`profile-billing-address-street-address_${this._uid}`"
            >Street address <span class="required">*</span></label
          >
          <input
            :id="`profile-billing-address-street-address_${this._uid}`"
            type="text"
            v-model="data.billing_address.street_address"
            @keydown="delete errors['billing_address.street_address']"
            placeholder="Enter street name"
          />
          <input-error v-if="errors['billing_address.street_address']">
            {{ errors["billing_address.street_address"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-suburb"
          :class="{ 'has-input-error': errors['billing_address.suburb'] }"
        >
          <label :for="`profile-billing-address-suburb_${this._uid}`"
            >Suburb <span class="required">*</span></label
          >
          <input
            :id="`profile-billing-address-suburb_${this._uid}`"
            type="text"
            v-model="data.billing_address.suburb"
            @keydown="delete errors['billing_address.suburb']"
            placeholder="Enter suburb"
          />
          <input-error v-if="errors['billing_address.suburb']">
            {{ errors["billing_address.suburb"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-state"
          :class="{ 'has-input-error': errors['billing_address.state.slug'] }"
        >
          <label :for="`profile-billing-address-state_${this._uid}`"
            >State <span class="required">*</span></label
          >
          <select-wrapper
            :append-to-body="false"
            :id="`profile-billing-address-state_${this._uid}`"
            :options="stateOptions"
            v-model="data.billing_address.state.slug"
            @input="delete errors['billing_address.state.slug']"
            placeholder="Select state"
          ></select-wrapper>
          <input-error v-if="errors['billing_address.state.slug']">
            {{ errors["billing_address.state.slug"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-postcode"
          :class="{ 'has-input-error': errors['billing_address.postal_code'] }"
        >
          <label :for="`profile-billing-address-postcode_${this._uid}`"
            >Postcode <span class="required">*</span></label
          >
          <input
            :id="`profile-billing-address-postcode_${this._uid}`"
            type="text"
            v-model="data.billing_address.postal_code"
            @keydown="delete errors['billing_address.postal_code']"
            placeholder="Enter postcode"
          />
          <input-error v-if="errors['billing_address.postal_code']">
            {{ errors["billing_address.postal_code"][0] }}
          </input-error>
        </div>
      </template>

      <template v-else>
        <div class="form-group vanilla address-full">
          <auto-complete-address
            @placechanged="fillAddress"
          ></auto-complete-address>
        </div>
        <div class="tablet-hidden">&nbsp;</div>
        <div class="form-group vanilla street-number-group">
          <div
            class="address-sub-premises"
            :class="{
              'has-input-error': errors['billing_address.sub_premises_number'],
            }"
          >
            <label :for="`profile-billing-address-sub-premises-number_${this._uid}`"
              >Unit/Flat</label
            >
            <input
              :id="`profile-billing-address-sub-premises-number_${this._uid}`"
              type="text"
              v-model="data.billing_address.sub_premises_number"
            />
            <input-error v-if="errors['billing_address.sub_premises_number']">
              {{ errors["billing_address.sub_premises_number"][0] }}
            </input-error>
          </div>
          <div
            class="address-street-number"
            :class="{ 'has-input-error': errors['billing_address.street_number'] }"
          >
            <label :for="`profile-billing-address-street-number_${this._uid}`"
              >Street number</label
            >
            <input
              :id="`profile-billing-address-street-number_${this._uid}`"
              type="text"
              v-model="data.billing_address.street_number"
              @keydown="delete errors['billing_address.street_number']"
            />
            <input-error v-if="errors['billing_address.street_number']">
              {{ errors["billing_address.street_number"][0] }}
            </input-error>
          </div>
        </div>
        <div
          class="form-group vanilla address-street-address"
          :class="{ 'has-input-error': errors['billing_address.street_address'] }"
        >
          <label :for="`profile-billing-address-street-address_${this._uid}`"
            >Street address</label
          >
          <input
            :id="`profile-billing-address-street-address_${this._uid}`"
            type="text"
            v-model="data.billing_address.street_address"
            @keydown="delete errors['billing_address.street_address']"
          />
          <input-error v-if="errors['billing_address.street_address']">
            {{ errors["billing_address.street_address"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-suburb"
          :class="{ 'has-input-error': errors['billing_address.suburb'] }"
        >
          <label :for="`profile-billing-address-suburb_${this._uid}`"
            >Suburb</label
          >
          <input
            :id="`profile-billing-address-suburb_${this._uid}`"
            type="text"
            v-model="data.billing_address.suburb"
            @keydown="delete errors['billing_address.suburb']"
          />
          <input-error v-if="errors['billing_address.suburb']">
            {{ errors["billing_address.suburb"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-state"
          :class="{ 'has-input-error': errors['billing_address.state.slug'] }"
        >
          <label :for="`profile-billing-address-state_${this._uid}`">State</label>
          <select-wrapper
            :append-to-body="false"
            :id="`profile-billing-address-state_${this._uid}`"
            :options="stateOptions"
            v-model="data.billing_address.state.slug"
            @input="delete errors['billing_address.state.slug']"
          ></select-wrapper>
          <input-error v-if="errors['billing_address.state.slug']">
            {{ errors["billing_address.state.slug"][0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla address-postcode"
          :class="{ 'has-input-error': errors['billing_address.postal_code'] }"
        >
          <label :for="`profile-billing-address-postcode_${this._uid}`"
            >Postcode</label
          >
          <input
            :id="`profile-billing-address-postcode_${this._uid}`"
            type="text"
            v-model="data.billing_address.postal_code"
            @keydown="delete errors['billing_address.postal_code']"
          />
          <input-error v-if="errors['billing_address.postal_code']">
            {{ errors["billing_address.postal_code"][0] }}
          </input-error>
        </div>
      </template>
    </div>
  </template>


  <script>
  const fields = {
    billing_address: {
      sub_premises_number: "",
      street_number: "",
      street_address: "",
      suburb: "",
      state: {
        slug: "",
      },
      postal_code: "",
    },
  };
  export { fields };

  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
      errors: {
        required: true
      },
      form_options: {
        type: Object,
        required: false
      }
    },
    methods: {
      fillAddress(result) {
        delete this.errors["billing_address.street_number"];
        delete this.errors["billing_address.street_address"];
        delete this.errors["billing_address.suburb"];
        delete this.errors["billing_address.state.slug"];
        delete this.errors["billing_address.postal_code"];
        this.data.billing_address = {
          sub_premises_number: result.subpremise || null,
          street_number: result.street_number || null,
          street_address: result.route || null,
          suburb: result.locality || null,
          state: {
            slug: result.administrative_area_level_1 || null,
          },
          postal_code: result.postal_code || null,
        };
      },
    },
    computed: {
      stateOptions() {
        let options = [];
        if ( this.form_options && this.form_options.states ) {
          for ( let state of this.form_options.states ) {
            options.push({id: state.slug, label: state.label});
          }
        }
        return options;
      }
    }
  };
  </script>
